import VueI18n from '@/libs/i18n/index';
import AppConstants from '@/appConstants';

class TranslateFieldHelper {
    translateBooleanToLocale(value) {
        return value ? VueI18n.t('BOOLEAN').Yes : VueI18n.t('BOOLEAN').No;
    }
    
    translateNewsStatusById(statusCode) {
        let status = '';
        switch (statusCode) {
            case AppConstants.NEWS_STATUS.SENDNOW:
                status = VueI18n.t('NEWS_STATUS').SENDNOW;
                break;
            case AppConstants.NEWS_STATUS.SAVED:
                status = VueI18n.t('NEWS_STATUS').SAVED;
                break;
            case AppConstants.NEWS_STATUS.SCHEDULED:
                status = VueI18n.t('NEWS_STATUS').SCHEDULED;
                break;
            case AppConstants.NEWS_STATUS.SENT:
                status = VueI18n.t('NEWS_STATUS').SENT;
                break;
            case AppConstants.NEWS_STATUS.ERROR:
                status = VueI18n.t('NEWS_STATUS').ERROR;
                break;
        }
        return status;
    }

}

export default new TranslateFieldHelper();